export default {
    /**
     * 获取文件访问URL
     * @param {string} path 文件相对路径
     * @returns {string} 文件访问URL
     */
    getResourceUrl(path) {
        if (path && typeof path === 'string') {
            return path.startsWith('/') ? `${window.$MIDE_CONFIG.resourceUrlRoot}${path}` : path;
        }
        return '';
    },
};
